const SAFE_REF_PATTERN = /^[A-Za-z0-9_-]{1,100}$/;

const PUBLIC_HYPOTHESIS_LP_PATHS = new Set([
  "/sales-support",
  "/president-consult",
  "/knowledge-use",
]);

export function getSafePublicLpRef(search: string): string | null {
  const ref = new URLSearchParams(search).get("ref");
  return ref && SAFE_REF_PATTERN.test(ref) ? ref : null;
}

export function buildPublicLpReturnTo(pathname: string, search: string): string | null {
  if (!PUBLIC_HYPOTHESIS_LP_PATHS.has(pathname)) return null;
  const ref = getSafePublicLpRef(search);
  return ref ? `${pathname}?ref=${encodeURIComponent(ref)}` : pathname;
}

export function resolvePublicLpReturnTo(value: string | null | undefined): string | null {
  if (!value || value.startsWith("//") || value.includes("#")) return null;

  try {
    const parsed = new URL(value, "https://wizmate.local");
    if (parsed.origin !== "https://wizmate.local" || !PUBLIC_HYPOTHESIS_LP_PATHS.has(parsed.pathname)) {
      return null;
    }

    const keys = Array.from(parsed.searchParams.keys());
    if (keys.some((key) => key !== "ref") || parsed.searchParams.getAll("ref").length > 1) {
      return null;
    }

    const ref = parsed.searchParams.get("ref");
    if (!ref) return parsed.search ? null : parsed.pathname;
    return SAFE_REF_PATTERN.test(ref)
      ? `${parsed.pathname}?ref=${encodeURIComponent(ref)}`
      : null;
  } catch {
    return null;
  }
}

export function buildPublicLpDestinationHref(destination: string, returnTo: string | null): string {
  return returnTo
    ? `${destination}?returnTo=${encodeURIComponent(returnTo)}`
    : destination;
}
